function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FFA700",
  d: "M3.2 16.66c-.2 3.2 8.1 11.9 12.3 11.9.6 0 1.1-.2 1.5-.6l.6-.6c.6-.6.6-1.5 0-2.1l-2.3-2.3c-.6-.6-1.5-.6-2.1 0l-1.2 1.5c-.9-.5-1.8-1.1-2.6-1.9-.8-.7-1.4-1.6-1.8-2.5l1.3-1.3c.6-.6.6-1.5 0-2.1l-2.3-2.3c-.6-.5-1.5-.5-2.1 0l-.6.6c-.5.5-.7 1-.7 1.7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE5EC",
  d: "M25.6 3.16h-9.4c-1 0-1.9.8-1.9 1.9v13.1l3.3-3.3h9.2c1 0 1.9-.8 1.9-1.9v-8.7c0-.6-.5-1.1-1.1-1.1h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A2B9C3",
  d: "M25 6.6h-6.9c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3H25c.2 0 .3.1.3.3s-.2.3-.3.3m0 2.8h-6.9c-.2 0-.3-.1-.3-.3s.1-.3.3-.3H25c.2 0 .3.1.3.3 0 .1-.2.3-.3.3m0 2.7h-6.9c-.2 0-.3-.1-.3-.3s.1-.3.3-.3H25c.2 0 .3.1.3.3s-.2.3-.3.3"
}));